/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanySetup } from '../models/CompanySetup';
import type { StripeSetupResponse } from '../models/StripeSetupResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompanySetupEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns CompanySetup
   * @throws ApiError
   */
  public companySetupRetrieve({
    drivingSchoolId,
  }: {
    drivingSchoolId: string,
  }): CancelablePromise<CompanySetup> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/company-setup/{driving_school_id}/',
      path: {
        'driving_school_id': drivingSchoolId,
      },
    });
  }

  /**
   * @returns StripeSetupResponse
   * @throws ApiError
   */
  public companySetupGetStripeSetupUrlRetrieve({
    drivingSchoolId,
  }: {
    drivingSchoolId: string,
  }): CancelablePromise<StripeSetupResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/company-setup/{driving_school_id}/get-stripe-setup-url/',
      path: {
        'driving_school_id': drivingSchoolId,
      },
    });
  }

}
